import { ButtonText } from "components/Atoms/Button";
import { PhosphorArrowClockwise, PhosphorCheck } from "components/Atoms/PhosphorIcon";
import { useMutation } from "@tanstack/react-query";
import React from "react";
import classNames from "classnames";

interface Props {
  participant: server.dto.InvoiceParticipant
}

export const ResendInvitationButton = (props: Props) => {

  const resendMutation = useMutation(window.CoreApi.InvoiceV2.ResendParticipantEmail);

  const resendInvitation = async () => {
    const result = await resendMutation.mutateAsync({ participantId: props.participant.invoiceParticipantId });
    if (result.data.hasErrors) {
      window.displayGenericModal(RESX.ExceptionMessage.ThereIsAProblem, result.data.errors[0].message, "mini", "red");
      return;
    }
  }

  const hasRotatedWithoutErrors = resendMutation.data != null && !resendMutation.data.data.hasErrors;

  const classes = classNames("flex gap-small", {
    "rotating-arrow-icon": !hasRotatedWithoutErrors,
    "is-rotating": resendMutation.isLoading
  });

  return <div className={classes}>
    <ButtonText
      disabled={resendMutation.isLoading}
      onClick={resendInvitation}
      label={RESX.Invitation.ResendInvitation}
      style={{ padding: 0 }}
    />

    {!hasRotatedWithoutErrors && <PhosphorArrowClockwise />}
    {hasRotatedWithoutErrors && <PhosphorCheck iconColor="green" />}

  </div>
}